import styled from 'styled-components';

export const Container = styled.div`
  display: flex !important;
  align-items: center !important;
`;
